module.exports = __webpack_public_path__ + "img/ytwk.a7aee0e9.png";